import { TicketDetail } from "./TicketDetail";

// Detail view for an RCS-portal ticket (uses RCS config — severities / request
// types tagged "rcs").
export const RcsTicket = () => <TicketDetail isRcs={true} />;
